import { render, staticRenderFns } from "./TenantFunction.vue?vue&type=template&id=2de59ab2&scoped=true&"
import script from "./TenantFunction.vue?vue&type=script&lang=js&"
export * from "./TenantFunction.vue?vue&type=script&lang=js&"
import style0 from "./TenantFunction.vue?vue&type=style&index=0&id=2de59ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de59ab2",
  null
  
)

export default component.exports